import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import OptionsBoard from '../Pages/OptionsBoard';
import UnusualOptionsActivity from '../Pages/UnusualOptionsActivity';
import OpenInterest from '../Pages/OpenInterest';
import StockHome from '../Pages/Stock';
import HomePageView from '../Pages/HomePage';
import WatchList from '../Pages/WatchList';
import NoAccess from '../Pages/NoAccess';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setAppStateAction } from '../actions/appStateAction';
import { fetchGeneralNews } from '../Shared/news';

const Routes = (props) => {
	const { loginCheck, refreshOpenInterest, fetchNews, fetchOpenInterest } =
		props;
	const dispatch = useDispatch();
	let { ticker } = useParams();
	const { appReducer } = useSelector((state) => state);
	const setAppState = (payload) => dispatch(setAppStateAction(payload));
	const { width, isMobile, accessLevel, redirectLink } = appReducer;

  useEffect(() => {
    setAppState({
      width: window.innerWidth,
      isMobile: window.innerWidth < 850 ? true : false,
    });
  }, [window.innerWidth]);

	useEffect(() => {
		if (!ticker === 'NULL' || !ticker) {
			fetchGeneralNews(setAppState);
			return;
		}
		fetchNews(ticker);
	}, [ticker]);

	const changeTicker = (ticker) => setAppState({ ticker, tickerChanged: true });

	const fullaccessCheck = accessLevel === 'fullaccess';
	const halfaccessCheck = accessLevel === 'halfaccess';

	const optionsBoard = (props) =>
		fullaccessCheck || halfaccessCheck ? (
			<OptionsBoard
				{...props}
				loginCheck={loginCheck}
				changeTicker={changeTicker}
			/>
		) : (
			<NoAccess isMobile={isMobile} />
		);

	const stockPage = (props) =>
		fullaccessCheck ? (
			<StockHome {...props} loginCheck={loginCheck} fetchNews={fetchNews} />
		) : (
			<NoAccess isMobile={isMobile} />
		);

	const openInterest = (props) =>
		fullaccessCheck ? (
			<OpenInterest
				{...props}
				loginCheck={loginCheck}
				isMobile={isMobile}
				changeTicker={changeTicker}
				refreshOpenInterest={refreshOpenInterest}
				fetchOpenInterest={(ticker) => fetchOpenInterest(ticker)}
			/>
		) : (
			<NoAccess isMobile={isMobile} />
		);

	return (
		<div>
			<Header />
			<Switch>
				<Route path='/' exact>
					<Redirect to='/home' />
					<Redirect to={redirectLink} />
				</Route>

				<Route path='/stocks' exact render={stockPage} />
				<Route path='/stocks/:ticker' render={stockPage} />
				<Route path='/optionschain' exact render={optionsBoard} />
				<Route path='/optionschain/:ticker' render={optionsBoard} />

				<Route
					path='/unusualoptionsactivity'
					render={(props) =>
						fullaccessCheck || halfaccessCheck ? (
							<UnusualOptionsActivity {...props} loginCheck={loginCheck} />
						) : (
							<NoAccess isMobile={isMobile} />
						)
					}
				/>

				<Route path='/openinterest' exact render={openInterest} />
				<Route path='/openinterest/:ticker' render={openInterest} />

				<Route
					path='/home'
					exact
					render={(props) =>
						fullaccessCheck ? (
							<HomePageView {...props} loginCheck={loginCheck} />
						) : (
							<NoAccess isMobile={isMobile} />
						)
					}
				/>

				<Route
					path='/watchlist'
					exact
					render={(props) =>
						accessLevel === 'fullaccess' ? (
							<WatchList loginCheck={loginCheck} {...props} />
						) : (
							<NoAccess isMobile={isMobile} />
						)
					}
				/>
			</Switch>
			{!isMobile && <Footer width={width} />}
		</div>
	);
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx